// Every dialog id lives here: `modalStore` holds one `activeDialog`, so ids are what keeps two
// dialogs from being open at once and what other features read to step aside. Where a dialog is
// *mounted* is a separate question — see `DIALOG_CONTAINERS`.
export const DIALOG_IDS = {
    giftSub: 'gift-sub',
    followers: 'followers',
    following: 'following',
    addToCollection: 'add-to-collection',
    createCollection: 'create-collection',
    deleteCollection: 'delete-collection',
    editCollectionAudio: 'edit-collection-audio',
    share: 'share',
    embed: 'embed',
    hqInfo: 'hq-info',
    download: 'download',
    firstLike: 'first-like',
    auth: 'auth',
    linkAudacity: 'link-audacity',
    audacityDownload: 'audacity-download',
    reportMissing: 'report-missing',
    paywall: 'paywall',
    checkout: 'checkout',
    purchaseSuccess: 'purchase-success',
    converterPromo: 'converter-promo',
    anniversaryPromo: 'anniversary-promo',
    hqStoragePaywall: 'hq-storage-paywall',
} as const

export type TDialogId = (typeof DIALOG_IDS)[keyof typeof DIALOG_IDS]
